<header class="header-cs">
  <div class="header-layout">
    <div class="title-wrap">
      <h4 class="map-title-cs">{{ 'select_site_location_tr' | translate }}</h4>
      <span class="map-hint-inline" [attr.aria-live]="'polite'">{{ hintText }}</span>
      @if (whispState) {
        <span
          data-testid="whisp-status"
          [attr.data-state]="whispState"
          [class]="'whisp-status whisp-status--' + whispState"
          [attr.aria-live]="'polite'"
        >
          <mat-icon aria-hidden="true">forest</mat-icon>
          {{ 'whisp_chip_' + whispState + '_tr' | translate: { count: whispRiskGroupCount } }}
        </span>
      }
      @if (canCheckWhispNow) {
        <button type="button" class="whisp-check-now" data-testid="whisp-check-now" (click)="checkWhispNow()">
          {{ 'whisp_check_now_tr' | translate }}
        </button>
      }
      @if (canSaveAndCheckWhisp) {
        <button
          type="button"
          class="whisp-check-now"
          data-testid="whisp-save-and-check"
          [title]="'whisp_save_and_check_hint_tr' | translate"
          (click)="saveAndCheckWhisp()"
        >
          {{ 'whisp_save_and_check_tr' | translate }}
        </button>
      }
    </div>

    <div class="map-header-center">
      @if (tracesStatus === 'held') {
        <button
          type="button"
          data-testid="traces-geo-status"
          data-state="held"
          class="traces-status traces-status--held"
          [title]="'traces_refresh_hint_tr' | translate"
          (click)="releaseTracesHold()"
        >
          <mat-icon aria-hidden="true">sync_problem</mat-icon>
          {{ 'traces_status_held_tr' | translate }}
        </button>
      } @else {
        <span
          data-testid="traces-geo-status"
          [attr.data-state]="tracesStatus"
          [class]="'traces-status traces-status--' + tracesStatus"
          [attr.aria-live]="'polite'"
        >
          <mat-icon aria-hidden="true">layers</mat-icon>
          {{ 'traces_status_' + tracesStatus + '_tr' | translate }}
        </span>
      }
    </div>

    <div class="button-row">
      <button
        type="button"
        class="icon-btn"
        [disabled]="!canUndo"
        (click)="undo()"
        [title]="'Map_undo_tr' | translate"
        [attr.aria-label]="'Map_undo_tr' | translate"
      >
        <mat-icon aria-hidden="true">undo</mat-icon>
      </button>
      <button
        type="button"
        class="icon-btn"
        [disabled]="!canRedo"
        (click)="redo()"
        [title]="'Map_redo_tr' | translate"
        [attr.aria-label]="'Map_redo_tr' | translate"
      >
        <mat-icon aria-hidden="true">redo</mat-icon>
      </button>
      <button
        (click)="openHelp()"
        class="icon-btn"
        type="button"
        [title]="'Map_help_tr' | translate"
        [attr.aria-label]="'Map_help_tr' | translate"
      >
        <mat-icon aria-hidden="true">help_outline</mat-icon>
      </button>
      <button
        type="button"
        class="icon-btn"
        data-testid="map-upload-button"
        [title]="'Map_import_shapes_tr' | translate"
        [attr.aria-label]="'Map_import_shapes_tr' | translate"
        (click)="handleUploadClick()"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M12 16V3m-4 4 4-4 4 4M4 15v5h16v-5" />
        </svg>
      </button>

      <button
        class="icon-btn"
        type="button"
        [title]="'Map_export_shapes_tr' | translate"
        [attr.aria-label]="'Map_export_shapes_tr' | translate"
        (click)="downloadAllPolygonsAsGeoJSON()"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M12 3v13m-4-4 4 4 4-4M4 16v4h16v-4" />
        </svg>
      </button>

      <button
        class="icon-btn"
        type="button"
        data-testid="map-save-close-button"
        [title]="'Map_save_close_tr' | translate"
        [attr.aria-label]="'Map_save_close_tr' | translate"
        (click)="saveAndClose()"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12l4 4v12a2 2 0 0 1-2 2Z" />
          <path d="M7 3v6h10V3M7 21v-8h10v8" />
        </svg>
      </button>
      <button
        type="button"
        class="icon-btn"
        (click)="requestClose()"
        [title]="'close_tr' | translate"
        [attr.aria-label]="'close_tr' | translate"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
  </div>
</header>
<div class="control-parking">
  <app-layers-panel
    [state]="overlays"
    [showWhisp]="hasRiskOutline"
    [showWhispDebug]="showWhispDebug"
    [whispStale]="whispStale"
    (stateChange)="applyOverlays($event)"
  />
  <app-whisp-debug-panel
    [view]="overlays.whispDebug ? whispDebug.view() : null"
    [siteGeo]="debugSiteGeo"
    [selectedPartId]="whispDebug.selectedPartId()"
    (selectPart)="whispDebug.select($event)"
  />
</div>

<!-- Hidden file input used by Upload button -->
<input
  #fileInput
  type="file"
  accept=".geojson,.json,.zip,.csv,.xls,.xlsx,.qgz,.gpx"
  style="display: none"
  (change)="onFileSelected($event)"
/>

<mat-dialog-content class="map-content-cs">
  <div #mapContainer id="map" class="height-100"></div>
  <div class="upload-overlay" *ngIf="isUploading">
    <div class="upload-panel">
      <div class="upload-spinner" aria-hidden="true"></div>
      <div class="upload-text">
        <div class="upload-title">{{ 'Uploading_file_tr' | translate }}</div>
        <div class="upload-progress">{{ uploadProgress }}%</div>
        <div class="upload-note" role="status">{{ uploadStatus }}</div>
        <div class="upload-note">{{ 'Large_GeoJSONs_can_take_a_moment_to_load_tr' | translate }}</div>
        <button type="button" (click)="cancelUpload()" style="text-transform: uppercase; padding: 6px 12px">
          {{ 'cancel_tr' | translate }}
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
